import { FileBase64 } from "../../../../model/file-base-64";
import { Pagination } from "../../../../model/pagination";
import { ISubmissionPublicationPagedRequest } from "../../../../model/sep/submission-publications/request/submission-publication-paged-request";
import { ISubmissionPublicationUpdateRequest } from "../../../../model/sep/submission-publications/request/submission-publication-update-request";
import { IUserSendSubmissionPublicationRequest } from "../../../../model/sep/submission-publications/request/user-send-submission-publication-request";
import { IStatusSubmissionPublicationResponse } from "../../../../model/sep/submission-publications/response/status-submission-publication-response";
import { ISubmissionPublicationDetailResponse } from "../../../../model/sep/submission-publications/response/submission-publication-detail-response";
import { ISubmissionPublicationFileResponse } from "../../../../model/sep/submission-publications/response/submission-publication-file-response";
import { ISubmissionPublicationPagedResponse } from "../../../../model/sep/submission-publications/response/submission-publication-paged-response";
import { IUserSendSubmissionPublicationResponse } from "../../../../model/sep/submission-publications/response/user-send-submission-publication-response";
import HttpClient from "../../../services/http-client";

const defaultPath = 'SubmissionPublication';

const findUsersSend = async (params: IUserSendSubmissionPublicationRequest): Promise<IUserSendSubmissionPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/UsersSend`,
        params: params
    }).then((response) => Object.assign([] as IUserSendSubmissionPublicationResponse[], response.data));
};


const update = async (content: ISubmissionPublicationUpdateRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${content.id}`,
        data: content
    });
};


const get = async (params: ISubmissionPublicationPagedRequest): Promise<Pagination<ISubmissionPublicationPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new Pagination<ISubmissionPublicationPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<ISubmissionPublicationDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as ISubmissionPublicationDetailResponse, response.data));
};


const listFiles = async (id: number): Promise<ISubmissionPublicationFileResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/Files`
    }).then((response) => Object.assign([] as unknown as ISubmissionPublicationFileResponse, response.data));
};


const downloadFiles = async (id?: number): Promise<FileBase64> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/Files/Download`
    }).then((response) => Object.assign(new FileBase64(), response.data));
};

const downloadFile = async (id: number, idFile: number): Promise<FileBase64> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/File/Download/${idFile}`
    }).then((response) => Object.assign(new FileBase64(), response.data));
};


const listStatus = async (): Promise<IStatusSubmissionPublicationResponse[]> => {
    return await
        HttpClient.executeRequest({
            method: 'get',
            url: `/${defaultPath}/Status`
        }).then((response) => Object.assign([] as IStatusSubmissionPublicationResponse[], response.data));
};

const SubmissionPublicationAppService = {
    findUsersSend, listStatus, get, getById, listFiles, downloadFile, downloadFiles, update
};

export default SubmissionPublicationAppService;